const RankingColumns = [
  {
    name: "RANK",
    value: "rank",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "COMPANY",
    value: "company",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "Group companies considered",
    value: "group_companies_considered",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "Headquarters (Country of Origin)",
    value: "headquarters_country_of_origin",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "Ultimate Holding /Parent company",
    value: "ultimate_holding_parent_company",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "Subsidiary / JV",
    value: "subsidiary_jv",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "Industry/ Sector",
    value: "industry_sector",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "Total Income",
    value: "total_income_cr",
    show: true,
    isBold: true,
    colSpan: 3,
  },
  {
    name: "",
    value: "total_income_bn_mn",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "",
    value: "total_income_yoy_change",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "Net Income",
    value: "net_income_cr",
    show: true,
    isBold: true,
    colSpan: 2,
  },
  {
    name: "",
    value: "net_income_yoy_change",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "PBIDT Excl. Other Income",
    value: "pbidt_excl_other_income_cr",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "Profit/Loss",
    value: "profit_loss_cr",
    show: true,
    isBold: true,
    colSpan: 5,
  },
  {
    name: "",
    value: "profit_loss_bn_mn",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "",
    value: "profit_loss_rank",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "",
    value: "profit_loss_yoy_change",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "",
    value: "profit_loss_per_of_total_income",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "Cash & Bank Balance",
    value: "cash_bank_balance_cr",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "Total Assets",
    value: "total_assets_cr",
    show: true,
    isBold: true,
    colSpan: 3,
  },
  {
    name: "",
    value: "total_assets_rank",
    show: true,
    isBold: true,
    colSpan: 3,
  },
  {
    name: "",
    value: "total_assets_yoy_change",
    show: true,
    isBold: true,
    colSpan: 3,
  },
  {
    name: "Share Capital",
    value: "share_capital_cr",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "Networth",
    value: "networth_cr",
    show: true,
    isBold: true,
    colSpan: 2,
  },
  {
    name: "",
    value: "networth_rank",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "RONW",
    value: "ronw_per",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "ROCE",
    value: "roce_per",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "Market Cap",
    value: "market_cap_cr",
    show: true,
    isBold: true,
    colSpan: 1,
  },
  {
    name: "P/E",
    value: "p_e_x",
    show: true,
    isBold: true,
    colSpan: 1,
  },
];

const RankingSubColumns = [
  {
    name: "",
    value: "rank",
    show: true,
    isBold: true,
  },
  {
    name: "",
    value: "company",
    show: true,
    isBold: true,
  },
  {
    name: "",
    value: "group_companies_considered",
    show: true,
    isBold: true,
  },
  {
    name: "",
    value: "headquarters_country_of_origin",
    show: true,
    isBold: true,
  },
  {
    name: "",
    value: "ultimate_holding_parent_company",
    show: true,
    isBold: true,
  },
  {
    name: "",
    value: "subsidiary_jv",
    show: true,
    isBold: true,
  },
  {
    name: "",
    value: "industry_sector",
    show: true,
    isBold: true,
  },
  {
    name: "₹ crore",
    value: "total_income_cr",
    show: true,
    isBold: true,
  },
  {
    name: "$bn/$mn",
    value: "net_income_cr",
    show: true,
    isBold: true,
  },
  {
    name: "YoY change %",
    value: "pbidt_excl_other_income_cr",
    show: true,
    isBold: true,
  },
  {
    name: "₹ crore",
    value: "profit_loss_bn_mn",
    show: true,
    isBold: true,
  },
  {
    name: "YoY change %",
    value: "profit_loss_rank",
    show: true,
    isBold: true,
  },
  {
    name: "₹ crore",
    value: "profit_loss_per_of_total_income",
    show: true,
    isBold: true,
  },
  {
    name: "₹ crore",
    value: "share_capital_cr",
    show: true,
    isBold: true,
  },
  {
    name: "$bn/$mn",
    value: "profit_loss_bn_mn",
    show: true,
    isBold: true,
  },
  {
    name: "RANK",
    value: "profit_loss_rank",
    show: true,
    isBold: true,
  },
  {
    name: "YoY change %",
    value: "profit_loss_yoy_change",
    show: true,
    isBold: true,
  },
  {
    name: "% of total income",
    value: "profit_loss_per_of_total_income",
    show: true,
    isBold: true,
  },
  {
    name: "₹ crore",
    value: "cash_bank_balance_cr",
    show: true,
    isBold: true,
  },
  {
    name: "₹ crore",
    value: "total_assets_cr",
    show: true,
    isBold: true,
  },
  {
    name: "Rank",
    value: "total_assets_rank",
    show: true,
    isBold: true,
  },
  {
    name: "YoY change %",
    value: "total_assets_yoy_change",
    show: true,
    isBold: true,
  },
  {
    name: "₹ crore",
    value: "share_capital_cr",
    show: true,
    isBold: true,
  },
  {
    name: "₹ crore",
    value: "networth_cr",
    show: true,
    isBold: true,
  },
  {
    name: "Rank",
    value: "networth_rank",
    show: true,
    isBold: true,
  },
  {
    name: "(%)",
    value: "ronw_per",
    show: true,
    isBold: true,
  },
  {
    name: "(%)",
    value: "roce_per",
    show: true,
    isBold: true,
  },
  {
    name: "₹ crore",
    value: "market_cap_cr",
    show: true,
    isBold: true,
  },
  {
    name: "X",
    value: "p_e_x",
    show: true,
    isBold: true,
  },
];

export { RankingColumns, RankingSubColumns };
